import {
  TextField,
  Box,
  IconButton,
  useTheme,
  MenuItem,
  Typography,
  Menu,
  Tooltip,
  Chip,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  Button,
  Stack,
  Breadcrumbs,
} from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import VisibilityIcon from "@mui/icons-material/Visibility";
import RedoIcon from "@mui/icons-material/Redo";
import UndoIcon from "@mui/icons-material/Undo";
import BlockIcon from "@mui/icons-material/Block";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AlarmOnIcon from "@mui/icons-material/AlarmOn";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import LockResetIcon from "@mui/icons-material/LockReset";
import EscalatorWarningIcon from "@mui/icons-material/EscalatorWarning";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
// import MatxCustomizer from "./Mailpdf";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import BalanceIcon from "@mui/icons-material/Balance";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { tokens, ColorModeContext } from "../../Theme";
import { useProSidebar } from "react-pro-sidebar";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { fetchListview } from "../../store/reducers/Listviewapireducer";
import useMediaQuery from "@mui/material/useMediaQuery";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import { Link } from "react-router-dom";
import { useContext } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { useState } from "react";
import { fnCsvFileUpload } from "../../store/reducers/Imguploadreducer";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { screenRightsData } from "../../store/reducers/screenRightsreducer";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import WysiwygIcon from "@mui/icons-material/Wysiwyg";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";
import PauseCircleOutlinedIcon from "@mui/icons-material/PauseCircleOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import NotStartedOutlinedIcon from "@mui/icons-material/NotStartedOutlined";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import EmailIcon from "@mui/icons-material/Email";
import {
  dataGridHeaderFooterHeight,
  dataGridHeight,
  dataGridRowHeight,
  formGap,
} from "../../ui-components/global/utils";
import { fetchExplorelitview } from "../../store/reducers/Explorelitviewapireducer";
import { Employeeautocomplete } from "../../ui-components/global/Autocomplete";
import FlagIcon from "@mui/icons-material/Flag";
import AddTaskIcon from "@mui/icons-material/AddTask";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TodayIcon from "@mui/icons-material/Today";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import axios from "axios";
import { AttachFile, Download } from "@mui/icons-material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import Swal from "sweetalert2";
import DownloadIcon from "@mui/icons-material/Download";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import styled from "@emotion/styled";
import { Visibility } from "@mui/icons-material";


const SkillReview = () => {
  const navigate = useNavigate();
  const colorMode = useContext(ColorModeContext);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const YearFlag = sessionStorage.getItem("YearFlag");
  var currentPage = parseInt(sessionStorage.getItem("currentPage"));
  const location = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  console.log("-----------------------", params);

  var accessID = params.accessID;
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [pageSize, setPageSize] = React.useState(20);
  const [page, setPage] = React.useState(currentPage || 0);
  const [collapse, setcollapse] = React.useState(false);
  var invoice;
  const mailData = useSelector((state) => state.listviewApi.mailData);
  const EMPID = sessionStorage.getItem("EmpId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const open = useSelector((state) => state.listviewApi.mailOpen);
  var screenName = params.screenName;
  // console.log("🚀 ~ file: Listview.jsx:54 ~ Listview ~ screenName", screenName);
  const year = sessionStorage.getItem("year");
  const listViewData = useSelector((state) => state.listviewApi.rowData);

  const loading = useSelector((state) => state.listviewApi.loading);
  const { UGA_ADD, UGA_VIEW, UGA_MOD, UGA_DEL, UGA_PROCESS, UGA_PRINT } =
    useSelector((state) => state.screenRights.data);

  const formatDateTime = (date) => {
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  const [empData, setempData] = useState(null);
  const [useCurrentEmp, setUseCurrentEmp] = useState(false);

  const listViewcolumn = useSelector((state) => state.listviewApi.columnData);
  const [selectedFile, setSelectedFile] = useState();
  const [uploadFile, setUploadFile] = useState();
  const compID = sessionStorage.getItem("compID");
  const EmpId = sessionStorage.getItem("EmpId");

  const YearRecorid = sessionStorage.getItem("YearRecorid");
  const companyID = sessionStorage.getItem("companyId");
  const isManager = sessionStorage.getItem("isManager");
  const isprojectmanager = sessionStorage.getItem("isprojectmanager");

  const [selectedDate, setSelectedDate] = useState("");

  function filterByID(item) {
    if (item.hide !== true) {
      return true;
    }
  }

  const columnShow = React.useMemo(
    () => listViewcolumn.filter(filterByID),
    [listViewcolumn]
  );
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  function CustomToolbar() {
    return (
      <GridToolbarContainer
        key={location.key}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography variant="h3">Skill Glow</Typography>
        </Box>
      </GridToolbarContainer>
    );
  }

  const handlePagechange = (pageno) => {
    setPage(pageno);
    sessionStorage.setItem("currentPage", pageno);
  };
  const isExamCompleted = (skill) => {
    const data = JSON.parse(
      localStorage.getItem(`skill_answers_${skill}`) || "{}"
    );
    const answeredCount = Object.keys(data).length;
    return answeredCount === 5;
  };
  const ToAssessment = (skill) => {
    const saved = localStorage.getItem(`skill_answers_${skill}`);
    if (saved) {
      const data = JSON.parse(saved);

      const questions = [
        { id: "q1", type: "mcq" },
        { id: "q2", type: "boolean" },
        { id: "q3", type: "rating" },
        { id: "q4", type: "text" },
        { id: "q5", type: "text" },
      ];

      const allAnswered = questions.every((q) => {
        const ans = data[q.id];
        if (q.type === "mcq") return Array.isArray(ans) && ans.length > 0;
        if (q.type === "rating") return typeof ans === "number" && ans > 0;
        return ans !== undefined && ans !== "";
      });

      if (allAnswered) {
        navigate("/Apps/skillglow/listpage/SkillGlow/SkillResultDashboard", {
          state: { skill },
        });
      } else {
        // Incomplete answers → go to exam
        navigate("/Apps/skillglow/listpage/SkillGlow/SkillExam", {
          state: { skill },
        });
      }
    } else {
      // No saved answers → start fresh exam
      navigate("/Apps/skillglow/listpage/SkillGlow/SkillExam", {
        state: { skill },
      });
    }
  };

  const ToSession = () => {
    navigate("/Apps/skillglow/listpage/SkillGlow/SkillReview");
  };
  const ToShowCase = () => {
    navigate("/Apps/skillglow/listpage/SkillGlow/SkillGlowShowCase");
  };
  const handleDownload = (row) => {
    alert(`Downloading file: ${row.document}`);
  };
  const columns = [
    // { field: "id", headerName: "Id", width: 90 },
    {
      field: "sno",
      headerName: "SL#",
      width: 90,
    },
    {
      field: "description",
      headerName: "Description",
      width: 400,
      editable: true,
    },
    {
      field: "document",
      headerName: "Document",
      width: 200,
      editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Tooltip title="View">
        <IconButton
          onClick={() => handleDownload(params.row)}
          color="primary"
          aria-label="download"
        >
          <Visibility />
        </IconButton>
        </Tooltip>
      ),
    },
  ];
  const rows = [
    { id: 1, sno: 1, description: "React Document", document: "React.docx" },
    {
      id: 2,
      sno: 2,
      description: "React native Document",
      document: "Reactnative.docx",
    },
    { id: 3, sno: 3, description: ".Net", document: "Microsoft.docx" },
  ];
  const fnLogOut = (props) => {
    Swal.fire({
      title: `Do you want ${props}?`,
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate("/Apps/TR027/Employees");
        }
      } else {
        return;
      }
    });
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        key={location.key}
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {broken && !rtl && (
          <IconButton
            sx={{ margin: "0 6 0 2" }}
            onClick={() => toggleSidebar()}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}
        {/* <Box sx={{ display: "flex", flexDirection: "row", gap: 10 }}>
          <Typography variant="h3">Skill Glow</Typography>
        </Box> */}
        <Breadcrumbs
          maxItems={3}
          aria-label="breadcrumb"
          separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
        >
          <Typography
            variant="h5"
            color="#0000D1"
            sx={{ cursor: "default" }}
            onClick={() => navigate('/Apps/skillglow/listpage')}
          >
            List Of Assessment
          </Typography>
          <Typography variant="h5" color="#0000D1" sx={{ cursor: "default" }}>
           List Of Session
          </Typography>
        </Breadcrumbs>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />

          {/* <Tooltip arrow title="Add">
            <IconButton>
              <AddOutlinedIcon
                onClick={() =>
                navigate(
                  "/Apps/skillglow/listpage/SkillGlow/SkillGlowShowCase/createshowcase"
                )
              }
              />
            </IconButton>
          </Tooltip> */}
          {/* <Tooltip arrow title="Upload Files">
            <IconButton color="primary">
              <CloudUploadIcon />
              <input
                type="file"
                name="docUpload"
                style={{ display: "none" }}
                onChange={(event) => {
                  const file = event.currentTarget.files[0];
                }}
              />
            </IconButton>
          </Tooltip> */}

          <GridToolbarExport
            printOptions={{ disableToolbarButton: true }}
            csvOptions={{
              fileName: `${screenName}`,
            }}
          />

          <Tooltip arrow title="Logout">
            <IconButton onClick={() => fnLogOut("Logout")} color="error">
              <LogoutOutlinedIcon />
            </IconButton>
          </Tooltip>
        </Box>
      </GridToolbarContainer>
    );
  }
  return (
    <React.Fragment>
      <Box m="5px">
        <Box
          m="5px 0 0 0"
          padding={2}
          height={dataGridHeight}
          sx={{
            "& .MuiDataGrid-root": {
              border: "none",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "none",
            },
            "& .name-column--cell": {
              color: colors.greenAccent[300],
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[800],
              // borderBottom: "none",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "none",
              backgroundColor: colors.blueAccent[800],
            },
            "& .MuiCheckbox-root": {
              color: `${colors.greenAccent[200]} !important`,
            },
            "& .odd-row": {
              backgroundColor: "",
              color: "", // Color for odd rows
            },
            "& .even-row": {
              backgroundColor: "#d0edec",
              color: "", // Color for even rows
            },
          }}
        >
          {/* {accessID === "TR123" && (
            <Box sx={{ fontSize: '12px' }}>
              {formatDateTime(new Date())}
            </Box>
          )}
          {accessID === "TR124" && (
            <Box sx={{ fontSize: '12px' }}>
              {formatDateTime(new Date())}
            </Box>
          )} */}

          <DataGrid
            sx={{
              "& .MuiDataGrid-footerContainer": {
                height: dataGridHeaderFooterHeight,
                minHeight: dataGridHeaderFooterHeight,
              },
            }}
            key={accessID}
            rows={rows}
            columns={columns}
            loading={loading}
            disableSelectionOnClick
            getRowId={(row) => row.id}
            rowHeight={dataGridRowHeight}
            headerHeight={dataGridHeaderFooterHeight}
            pageSize={pageSize}
            page={page}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[5, 10, 15, 20]}
            onPageChange={(pageno) => handlePagechange(pageno)}
            components={{
              Toolbar: CustomToolbar,
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "odd-row"
                : "even-row"
            }
          />
        </Box>

        <Box display="flex" flexDirection="row" padding="25px" gap={2}>
          <Chip
            icon={<Visibility color="primary" />}
            label="View"
            variant="outlined"
          />
        </Box>
      </Box>
      {/* <MatxCustomizer open={open}screenName={invoice} rowData={mailData} type={""} /> */}
    </React.Fragment>
  );
};
export default SkillReview;
